module.exports = __webpack_public_path__ + "img/FIAT.8189f4c.jpg";